import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Download: React.FC<IconComponentProps> = ({
  className,
  strokeWidth = '1.5',
}) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.7322 8.00003C14.7322 4.28197 11.7181 1.26788 8.00003 1.26788C4.28197 1.26788 1.26788 4.28197 1.26788 8.00003C1.26788 11.7181 4.28197 14.7322 8.00003 14.7322C11.7181 14.7322 14.7322 11.7181 14.7322 8.00003Z"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.92859 9.55359L8.00002 11.625L10.0714 9.55359"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 4.375V11.625"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
